export const select2HashtagOption = {
    placeholder: "<Hashtag>",
    multiple: "multiple",
    theme: "select2-builder-multiple-gray",
    width: 'auto',
    dropdownAutoWidth: true
}
 